import MasterCrudPage from "../../components/MasterCrudPage";
import { userRoleApi } from "../../api/masterApi";

export default function UserRole() {
  return (
    <MasterCrudPage
      title="User Role"
      description="Define user roles for system accounts (e.g. Service Providers, Suppliers, Customers)."
      idKey="user_role_id"
      api={userRoleApi}
      listLabel="user roles"
      useJson
      fields={[
        {
          name: "user_role",
          label: "User Role",
          type: "text",
          required: true,
          placeholder: "e.g. Service Providers, Suppliers, Customers",
          fullWidth: true,
        },
        { name: "status", label: "Status", type: "checkbox" },
      ]}
      columns={[
        { key: "user_role_id", label: "User Role" },
        { key: "user_role", label: "User Role" },
        { key: "status", label: "Status", type: "status" },
      ]}
    />
  );
}
